import { Button, Icon, makeStyles } from '@material-ui/core';
import clsx from 'clsx';
import React, { useState } from 'react';
import { CirclePicker } from 'react-color';
import { CALENDAR_COLOURS, CALENDAR_DEFAULT_COLOUR } from '../../../constants';

const useStyle = makeStyles(() => ({
  swatch: {
    background: '#fff',
    borderRadius: '1px',
    boxShadow: '0 0 0 1px rgba(0,0,0,.1)',
    display: 'inline-flex',
    cursor: 'pointer',
    width: 'fit-content',
    justifyContent: 'flex-start',
  },
}));

const ColorPicker = (props) => {
  const { onColorChange, defaultColor, onChange, value, permanent = false } = props;
  const classes = useStyle();
  const [background, setBackground] = useState(defaultColor || value || CALENDAR_DEFAULT_COLOUR);
  const [displayColorPicker, setDisplayColorPicker] = useState(false);

  const showColor = CALENDAR_COLOURS;

  const _onColorChange = React.useCallback(
    (color) => {
      if (onColorChange) onColorChange(color.hex);
      if (onChange) onChange(color.hex);
      setBackground(color.hex);
      setDisplayColorPicker(false);
    },
    [onColorChange, onChange],
  );

  const handleDisplayColor = () => {
    setDisplayColorPicker(!displayColorPicker);
  };

  return permanent ? (
    <CirclePicker colors={showColor} onChange={_onColorChange} value={background} />
  ) : (
    <div style={{ display: 'flex', width: '100%', justifyContent: 'flex-start', alignItems: 'center' }}>
      <Button className={clsx(classes.swatch)} onClick={handleDisplayColor}>
        <div
          style={{
            width: '30px',
            height: '30px',
            borderRadius: '50%',
            backgroundColor: `${background}`,
          }}
        />
        <Icon>navigate_next</Icon>
      </Button>
      {displayColorPicker && <CirclePicker colors={showColor} onChange={_onColorChange} value={background} />}
    </div>
  );
};

export default ColorPicker;
